<script setup lang="ts">
const props = defineProps<{
  variant: SingleProductVariant
}>()

const price = usePrices(props.variant)
</script>

<template>
  <summary
    class="flex gap-2 group items-center group cursor-default flex-wrap md:flex-nowrap"
    :style="variant.textColor && `color: ${variant.textColor}`"
  >
    <div class="shrink mr-auto">
      <h4 class="text-xl font-semibold group-hover:underline" v-text="variant.title" />
      <p v-if="variant.languages?.length && variant.subtitle">
        {{ variant.subtitle }}
      </p>
      <p v-else-if="variant.subtitle" v-text="variant.subtitle" />
      <span
        v-else-if="variant.languages?.length"
        class="font-medium"
        v-text="languages(variant)"
      />
    </div>

    <IconsDiscount
      v-if="price !== 'NOT_APPLICABLE' && price?.discounted"
      size="small"
      class="[--background:white] [--color:var(--color-coral-pop)] [--stroke:none] flex-none"
    />

    <div class="flex gap-2 flex-none flex-wrap md:flex-nowrap max-w-full">
      <span
        v-if="variant.productForm"
        class="flex items-center rounded-sm bg-(--theme-5) px-4 py-3"
      >
        <UIcon v-if="variant.productForm === 'PAPER'" name="far:book-open" />
        <UIcon v-else-if="variant.productForm === 'DIGITAL'" name="far:display" />
      </span>
      <span
        v-if="variant.release"
        class="rounded-sm bg-(--theme-5) px-4 py-3"
      >
        {{ variant.release }}. utgave
      </span>
      <span
        v-if="variant.languages?.length && variant.subtitle"
        class="rounded-sm bg-(--theme-5) px-4 py-3"
        v-text="languages(variant)"
      />
      <span class="rounded-sm bg-(--theme-50) px-4 py-3 font-semibold text-white uppercase" v-text="getFormattedFormats(variant)" />
    </div>


    <div class="flex flex-none rounded-full bg-(--theme-50) p-3 text-white">
      <UIcon name="far:chevron-down" class="group-open:hidden size-5" />
      <UIcon name="far:xmark" class="hidden group-open:inline-block size-5" />
    </div>
  </summary>
</template>

